'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weeks;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/weeks.js
// module id = 751
// module chunks = 0